import { formatNumber } from '@/utils/formatNumber'
import { Trans } from '@lingui/react/macro'
import { useWallet } from '@solana/wallet-adapter-react'
import { LAMPORTS_PER_SOL } from '@solana/web3.js'
import { useFetchUserWallet } from '../api'
import { LinkWalletButton } from './LinkWalletButton'

type WalletBlockProps = {
  balance: number
}

export const WalletBlock = ({ balance }: WalletBlockProps) => {
  const { publicKey } = useWallet()
  const { data: userWallet } = useFetchUserWallet()

  return (
    <div className="rounded-xl border border-gray-100 p-6">
      <div className="flex items-center justify-center border-b border-gray-100 pb-6">
        <LinkWalletButton className="h-10! text-base!" />
      </div>
      <div className="flex flex-col gap-6 py-6">
        <div className="grid grid-cols-2">
          <div className="flex grow flex-col gap-2">
            <span className="text-body-3 text-gray-90">
              <Trans>Balance</Trans>
            </span>
            <span className="text-gray-70 font-semibold">
              {publicKey && userWallet?.wallet?.walletAddress === publicKey.toString()
                ? `${Number(balance.toFixed(2))} SOL`
                : '-'}
            </span>
          </div>
          <div className="flex grow flex-col gap-2 border-l border-gray-100 pl-5">
            <span className="text-body-3 text-gray-90">
              <Trans>You Have Staked</Trans>
            </span>
            <span className="text-gray-70 font-semibold">
              {userWallet?.wallet?.walletAddress
                ? `${Number(((userWallet?.wallet?.stakeLamports || 0) / LAMPORTS_PER_SOL).toFixed(2))} SOL`
                : '-'}
            </span>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2 border-t border-gray-100 pt-6">
        <span className="text-body-3 text-gray-90">
          <Trans>You Have Earned</Trans>
        </span>
        <span className="text-gray-70 font-semibold">
          {userWallet?.stakingPoints ? `${formatNumber(userWallet.stakingPoints, 0)} $DATA Points` : '-'}
        </span>
      </div>
    </div>
  )
}
